import { useMemo } from 'react';

import { usePlatformExecuteAdHocQueryTeam } from '@cloudquery/api-platform';

import { useBaseAuthenticated } from '@cloudquery/base-users';

import { resourceCategoriesSQLQuery } from '../constants/data';
import { AssetResourceCategoryMenuItem } from '../types';
import { convertResourcesDataToMenuItem } from '../utils/tableState';

export const useAssetInventoryResourceCategories = (
  hideAllData: boolean,
): {
  isFetching: boolean;
  resourceCategories: AssetResourceCategoryMenuItem[];
  resourceCategoriesTotalCount: number;
} => {
  const { currentMembership } = useBaseAuthenticated();
  const { data, isFetching } = usePlatformExecuteAdHocQueryTeam(
    currentMembership.team.name ?? '',
    { query: resourceCategoriesSQLQuery },
    { per_page: 1000 },
  );

  const { menuItems, totalCount } = useMemo(() => {
    const rows = data?.data?.data?.rows;
    if (!rows || rows.length === 0) {
      return { menuItems: [], totalCount: 0 };
    }

    const { menuItems: items, resourceCategoriesTotalCount } = convertResourcesDataToMenuItem(
      rows,
      hideAllData,
    );

    return { menuItems: items, totalCount: resourceCategoriesTotalCount };
  }, [data, hideAllData]);

  return {
    isFetching,
    resourceCategories: menuItems,
    resourceCategoriesTotalCount: totalCount,
  };
};
